<script setup lang="ts">
import AccountBOInfoForm from '@/modules/account/components/AccountBOInfoForm.vue'
import AccountPermsForm from '@/modules/account/components/AccountPermsForm.vue'
import { Icon } from '@iconify/vue'
import { computed, onMounted, ref } from 'vue'
import { AccountBOActionType, useAccountBODetailStore } from '../stores/account.bo.detail.store'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import AccountAPI from '../constants/account.api.uri.const'
import { useToast } from 'primevue'
import { formDataUpdateAccount } from '../helper/form'
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue'
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth'
import CsButton from '@/components/ui/button/CsButton.vue'

const authStore = useAuthStore()
const accountBODetailStore = useAccountBODetailStore()

interface Props {
  id: number
}
const toast = useToast()

const props = defineProps<Props>()

const boDetailEditable = ref(false)
const boPermsEditable = ref(false)
const fetched = computed(() => {
  return accountBODetailStore.accounts[props.id]?.action_type
})

const requestFetchData = () => {
  try{
    accountBODetailStore.fetchAccountBO(Number(props?.id))
  } catch (e: unknown) {

  }
}

const accountBODetail: any = computed(() => {
  return accountBODetailStore.accounts[props.id]?.account || null
})

onMounted(() => {
  requestFetchData()
})

const updatePerms = async (perms: string[]) => {
  try{
    const formData = formDataUpdateAccount({
      ...accountBODetail.value,
      permissions: perms,
    })
    const res = await APIClient.put(AccountAPI.bo.update.replace(':id', formData.id.toString()), formData);
    if (res.data.code === 200) {
      toast.add({ severity: 'success', summary: 'Success', detail: 'Cập nhật thông tin thành công', life: 3000 });
      boPermsEditable.value = false;
      accountBODetailStore.setAccount(props.id, {
        permissions: perms,
        permissions_original: perms,
      })
      if (authStore.user.id === props.id) {
        authStore.setPerms(perms)
      }
    }
  } catch (e: any) {
    const errorMessage = e.response?.data?.errors[0]?.error || 'Đã có lỗi xảy ra';
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
  }
}


const handleSavePerms = () => {
  const perms = accountBODetailStore.accounts[props.id].account.permissions;

  boPermsEditable.value = false
  updatePerms(perms)
}

const cancelEdit = () => {
  boPermsEditable.value = false;
  accountBODetailStore.setAccount(props.id, {
    permissions: accountBODetail.value.permissions_original,
  })
}

</script>

<template>
  <template v-if="AccountBOActionType.FETCHING === fetched">
    <Card>
      <template #content>
        <div class="flex gap-3">
          Đang tải dữ liệu <Icon icon="eos-icons:three-dots-loading" width="24" height="24" />
        </div>
      </template>

    </Card>
  </template>
  <template v-if="AccountBOActionType.FETCH_FAILED === fetched">
    <Card class="bg-red-300">
      <template #content>
        <div class="flex flex-col gap-3 items-center">
          <Icon icon="fluent-color:error-circle-16" width="50" />
          <span class="font-300 text-[16px]">Lỗi khi tải dữ liệu này</span>
        </div>
      </template>

    </Card>
  </template>
  <template v-if="AccountBOActionType.FETCHED === fetched">
    <div class="flex gap-5 mb-5">
      <AccountBOInfoForm :id="props.id" action="update"/>
      <div class="flex flex-5 flex-col">
        <Card>
          <template #title>
            <div class="flex justify-between">
              <div>Quyền hạn</div>
              <div class="flex gap-2" v-if="accountBODetail?.deleted_at === null">
                <AllowPerm perm="account.edit_bo_perms" action="hide">
                  <CsButton
                    :visible="boPermsEditable"
                    type="button"
                    text="Lưu chỉnh sửa"
                    @click="handleSavePerms"
                  />
                  <CsButton
                    type="button"
                    icon="ri:edit-2-fill"
                    text="Chỉnh sửa"
                    :visible="!boPermsEditable"
                    @click="boPermsEditable = true"
                  />
                  <CsButton
                    type="button"
                    icon="ri:close-circle-fill"
                    text="Huỷ chỉnh sửa"
                    variant="danger"
                    :visible="boPermsEditable"
                    @click="cancelEdit"
                  />
                </AllowPerm>
              </div>
            </div>
          </template>
          <template #content>
            <AccountPermsForm :id="props.id" :editable="boPermsEditable" />
          </template>
        </Card>
      </div>
    </div>
  </template>
</template>

<style scoped>

</style>
